import { Component } from '@angular/core';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { ROLE_TDRATES_WRITE } from '../shared/constants';

@Component({
  selector: 'eaa-can-write-td-rates',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanWriteTdRatesComponent {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  ngOnInit(): void {
    this.authService.hasRole$(ROLE_TDRATES_WRITE).subscribe((hasRole) => (this.canView = hasRole));
  }
}
